import { getActivePinia, Pinia, Store } from 'pinia'
import { useUserStore, useDeviceStore } from '@/store/user'

interface ExtendedPinia extends Pinia {
    _s: Map<string, Store>
}

/**
 * ���[�U�X�g�A�ȊO�̃A�N�e�B�u�ȃX�g�A�����Z�b�g����
 */
export const resetStore = (): void => {
    const userStore = useUserStore();
    const deviceStore = useDeviceStore;

    const pinia = getActivePinia() as ExtendedPinia
    if (pinia) {
        // ���[�U&�f�o�C�X�ȊO�̃X�g�A�����Z�b�g����
        pinia._s.forEach((store, name) => {
            if (name != userStore.$id && name != deviceStore.$id) {
                store.$reset();
            }
        })
    }
}

